import { styled } from '@vebox/etui-system';
import { Div } from '@vebox/etui-system-elements';

export const AccordionDiv = styled(Div).attrs(({ theme, ...rest }) => ({
  bg: 'inherit',
  color: theme.palette.text.primary,
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.fontSizeBase,
  fontWeight: theme.typography.fontWeightRegular,
  lineHeight: theme.typography.lineHeightBase,
  ...rest,
}))``;
